import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Image} from "../../../core/components/image/image";
import {ScoresEmptyStateLiveRequestParams} from "../../../core/components/scores-placeholders/empty-state/assest/scores-empty-state.live.request-params";
import styles from '../styles/competitor-players-stats-module.module.scss';
import classnames from "classnames";
export class CompetitorPlayersStatsModuleEmptyStateProps extends BaseProps {
  isSmallView: Boolean;
  imageWidth: Boolean;
  imageHeight: Boolean;
  label: String;
}

export const CompetitorPlayersStatsModuleEmptyState = (props: CompetitorPlayersStatsModuleEmptyStateProps) => {
  const iconProps = {
    className: classnames(styles.empty_state_image),
    src: new ScoresEmptyStateLiveRequestParams(props.imageWidth, props.imageHeight)
  }

  return (
    <div className={classnames(styles.empty_state_container)}>
      <Image {...iconProps}/>
      <div className={classnames(styles.empty_state_label)}>{props.label}</div>
    </div>
  )
}
